import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyAgreement = lazy(async () => await import('./agreement'));

export const AgreementRouter: RouteObject = {
  path: 'agreement',
  element: <LazyAgreement />
};
